
import './HomePage.css';
import { motion } from "framer-motion";
import React from 'react';


import ServiceShowcase from "../components/ServiceShowcase";
import ExpertiseComponent from '../components/ExpertiseComponent';
import { Footer } from '../components/ConstantComponent';
import AchievementsSection from "../components/AchievementsSection.jsx";
import StatsBanner from "../components/StatsBanner/StatsBanner";
import WhyChoose from "../components/WhyChoose/WhyChoose";
import Product from "../components/Product";
import Clients from "../components/Clients";
import aboutImage from "../assets/about-power.jpg";
import Contact from "../components/Contact";




import heroVideo from "../assets/videos/hero-video.mp4";






/*******************************************************
 * Data Items
 *******************************************************/

const services = [
  {
    id: "grid-compliance",
    imagePath: require('../assets/grid-compliance-study.png'),
    serviceName: "Grid Compliance Study",
    features: ["Steady State and Dynamic State studies", "Power Quality assessment", "Modelled using PSS/e and PSCAD"],
    service_desc: `We offer a grid compliance study for wind/solar projects: 

    -Steady State study 
    -Dynamic State study 
    -Power Quality Study.

    Our team leverages industry-leading tools like <span class="highlight">PSS/e</span> and <span class="highlight">PSCAD</span> to deliver exceptional results`
  },
  {
    id: "evacuation-study",
    imagePath: require('../assets/evacuation-study.jpg'),
    serviceName: "Evacuation Study",
    features: ["50,000+ MW of evacuation studies delivered", "STU/CTU substation assessment", "End-to-end technical evaluation"],
    service_desc: `To assess satisfactory evacuation of proposed Wind/Solar power generation from STU/CTU Substation. 

    IPR has carried out more than <span class="highlight">50,000 MW</span> of evacuation study.`
  },
  {
    id: "protection-study",
    imagePath: require('../assets/protection-study.png'),
    serviceName: "Protection Study",
    features: ["Full plant SLD modelling", "Protection relay coordination", "Reliability-focused engineering"],
    service_desc: "The main objective of the study is to provide protection relay setting for the project  through modelling entire Wind/Solar/ plant SLD."
  },
  {
    id: "wind-solar-optimization",
    imagePath: require('../assets/optimization.jpg'),
    serviceName: "Wind/Solar Optimization",
    features: ["Full-capacity plant simulation", "Investment optimization analysis", "Technical loss level assessment"],
    service_desc: `Optimisation includes details modelling & Simulation of entire capacity of  Wind/ Solar plant to analyze the  various technical parameters from the perspective of investment optimisation & technical  loss level assessment.`
  },
  {
    id: "software-development",
    imagePath: require('../assets/software.jpg'),
    serviceName: "Software Devlopment",
    features: ["Native mobile & web applications", "PC application development", "Proven delivery for engineering clients"],
    service_desc: `We have a highly Experienced team in creating high performance, feature-packed native Mobile, Web and PC Application.

    We have built great set of applications for our clients.`
  },
  {
    id: "technical-consultancy",
    imagePath: require('../assets/technical-consultant.jpg'),
    serviceName: "Technical Consultancy & Due-Diligence of Projects",
    features: ["Full site technical audits", "Loss level analysis", "Investment-grade due-diligence"],
    service_desc: "Due-Diligence of Wind/Solar Projects to analyse loss levels and complete audit of site."
  },
  {
    id: "transmission-planning",
    imagePath: require('../assets/planning.jpg'),
    serviceName: "Transmission Planning and Grid Studies",
    features: ["State-wide load flow simulation", "Transmission congestion analysis", "Grid network planning support"],
    service_desc: "Load flow study Simulation of State transmission Grid network to derive Transmission system congestion."
  },
  {
    id: "power-quality",
    imagePath: require('../assets/pq-wave.jpg'),
    serviceName: "Power Quality Measurement",
    features: ["Harmonics measurement", "DC injection & flicker analysis", "Grid India / RLDC compliant"],
    service_desc: `Measurment of harmonics, direct current injection & flicker as per <span class="highlight">Grid India/RLDC</span> Guidelines`
  },
  {
    id: "power-system-consultancy",
    imagePath: require('../assets/power-system-consultancy.jpg'),
    serviceName: "Power System Consultancy",
    features: ["Generation, transmission & substation design", "Feasibility & cost analysis", "Regulatory & safety compliance"],
    service_desc: `Providing technical expertise for the design of new Generation plants, transmission lines, and substations.

    Assisting with feasibility studies and cost analysis of potential projects.
    Ensuring designs comply with relevant regulations and safety standards`
  },
  {
    id: "substation-design",
    imagePath: require('../assets/substation-design.jpg'),
    serviceName: "Substation Design Consultancy",
    features: ["SLDs & layout drawings", "Equipment specifications", "Protection & metering design"],
    service_desc: `Preparation of Basic Concept Report including SLD, Layouts, Sectional drawings, Equipment Specifications, Protection and Metering.`
  },
]




const HomePage = () => {


  return (
    <div className="home">

      {/* <NavHome /> */}

      <div className="hero-section" id="home">


        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={heroVideo} type="video/mp4" />
        </video>

        <div className="hero-overlay"></div>

        <div className="hero-content">

          <motion.p
            className="hero-text"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.25, 0.1, 0.25, 1] }}
          >
            Building the Future of
          </motion.p>

          <motion.p
            className="hero-text-main"
            initial={{ opacity: 0, y: 40, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 1, ease: [0.25, 0.1, 0.25, 1], delay: 0.25 }}
          >
            Power Systems
          </motion.p>

        </div>

      </div>
      {/* ===========================
      ABOUT US
=========================== */}

      {/* ===========================
ABOUT US
=========================== */}

      <section className="about-section" id="about">

        <div className="about-container">

          <motion.div
            className="about-left"
            initial={{ opacity: 0, y: 70, scale: 0.98 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1]
            }}
          >

            <p className="about-subtitle">
              ABOUT US
            </p>

            <h2 className="about-title">
              Engineering the Future of Sustainable Power
            </h2>

            <p className="about-description">
              At IPR Technologies Pvt. Ltd., we guide businesses through the
              transition to wind and solar energy with expert consultancy and
              end-to-end project support. Our expertise spans power system
              studies, grid compliance, renewable energy integration,
              simulation, and engineering solutions that deliver reliable,
              efficient, and future-ready power systems.
            </p>

            <div className="about-features">

              <div className="feature-item">✓ Power System Studies</div>
              <div className="feature-item">✓ Grid Compliance</div>
              <div className="feature-item">✓ Renewable Energy</div>
              <div className="feature-item">✓ Wind & Solar Integration</div>
              <div className="feature-item">✓ Hybrid Energy Solutions</div>
              <div className="feature-item">✓ Power System Simulation</div>

            </div>

          </motion.div>

          <motion.div
            className="about-right"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
          >

            <img
              src={aboutImage}
              alt="About IPR Technologies"
              className="about-image"
            />

          </motion.div>

        </div>

      </section>



      <section id="services">
        <ServiceShowcase />
      </section>


      <section id="expertise">
        <ExpertiseComponent />
      </section>



      <section id="achievements">
        <AchievementsSection />
      </section>

      <section id="stats-banner">
        <StatsBanner />
      </section>

      <section id="why-choose">
        <WhyChoose />
      </section>

      <Clients />

      <section id="products">
        <Product />
      </section>

      <Contact />

      <Footer />


    </div >
  );
};



export default HomePage;

